import React from 'react';
import { motion } from 'framer-motion';

const Stats = () => {
  const stats = [
    { label: "Engineers Deployed", value: "500", suffix: "+" },
    { label: "Projects Delivered", value: "120", suffix: "+" },
    { label: "Client Retention", value: "95", suffix: "%" },
    { label: "Tech Stacks", value: "30", suffix: "+" },
  ];

  return (
    <section className="py-24 bg-blue-900 text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-br from-blue-900 via-indigo-900 to-black opacity-90"></div>
      
      {/* Background decoration */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute top-0 left-1/4 w-96 h-96 bg-blue-500 rounded-full blur-[120px] opacity-20"></div>
        <div className="absolute bottom-0 right-1/4 w-96 h-96 bg-purple-500 rounded-full blur-[120px] opacity-20"></div>
      </div>

      <div className="container mx-auto px-4 max-w-6xl relative z-10 text-center">
        <h2 className="text-3xl md:text-5xl font-bold mb-16 text-white leading-tight">
          Delivering Impact at Scale
        </h2>
        
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat, index) => (
            <motion.div 
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              className="flex flex-col items-center"
            >
              <span className="font-display text-5xl md:text-6xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-blue-300 to-white mb-2 tracking-tighter">
                {stat.value}{stat.suffix}
              </span>
              <span className="text-sm md:text-base font-medium text-blue-200 uppercase tracking-widest opacity-80">{stat.label}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
